// extracted by mini-css-extract-plugin
export var inner = "Info-module--inner--1iSP3";
export var image = "Info-module--image--XxBvE";
export var infoItem = "Info-module--infoItem--3LLxf";
export var heading = "Info-module--heading--1ae0f";
export var description = "Info-module--description--1K1fI";